module.exports = __webpack_public_path__ + "static/media/save-template.3741146c.png";